import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import Button from "../../Button/Button/Button.js";
import { useIsPhone } from "../../MediaQuery/MediaQuery/MediaQueryContext.js";
/* empty css                 */
const ModalFooter = ({
  ctaCaption,
  onCancel,
  onCta,
  ctaButtonType,
  cancelCaption,
  associatedFormId,
  ctaLoading = false,
  className
}) => {
  const isPhone = useIsPhone();
  const { getLabel } = useIntl();
  const cancelProps = React.useMemo(
    () => ({
      "data-t": "modal-footer-cancel-button",
      className: "modal-footer__button",
      caption: cancelCaption ?? getLabel("common.actions.cancel"),
      "aria-label": cancelCaption ?? getLabel("common.actions.cancel"),
      variant: "outline",
      onClick: onCancel
    }),
    [cancelCaption, getLabel, onCancel]
  );
  const ctaProps = React.useMemo(
    () => ({
      "data-t": "modal-footer-cta-button",
      className: "modal-footer__button",
      caption: ctaCaption,
      "aria-label": ctaCaption,
      variant: "solid",
      onClick: onCta,
      type: ctaButtonType,
      form: associatedFormId,
      isLoading: ctaLoading
    }),
    [associatedFormId, ctaButtonType, ctaCaption, ctaLoading, onCta]
  );
  return /* @__PURE__ */ React.createElement("div", { className: classnames("modal-footer", className) }, isPhone ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { ...ctaProps }), /* @__PURE__ */ React.createElement(Button, { ...cancelProps })) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { ...cancelProps }), /* @__PURE__ */ React.createElement(Button, { ...ctaProps })));
};
export {
  ModalFooter as default
};
//# sourceMappingURL=ModalFooter.js.map
